module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/phone-model-mobile.ce90a512.png";